import { AxiosResponse } from "axios"
import ConnectApi from "../../baseService"
import { TApiResponse } from "../../TApiResponse"
import {
  TBusyoInfoGetRes,
  TBusyoListGetReq,
  TBusyoRegisterPostReq,
} from "./TBusyo"

/**
 * 部所マスタに対するAPIリクエスト用サービス
 *
 * @export
 * @class MenuService
 * @extends {ConnectApi}
 */
export default class BusyoService extends ConnectApi {
  /**
   * 検索取得
   *
   * @param {TMenuInfoGetReq} params
   * @param {(param: TApiResponse<TMenuInfoGetRes[]>) => any} resolve
   * @param {(param: TApiResponse<TMenuInfoGetRes[]>) => any} reject
   * @memberof MenuService
   */
  getList = async (params: TBusyoListGetReq, signal?: AbortSignal) => {
    try {
      const res: AxiosResponse<TApiResponse<TBusyoInfoGetRes[]>> =
        await this.getInner(`/master/busyo`, params, signal)
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 単体取得
   *
   * @param {TMenuInfoGetReq} params
   * @param {(param: TApiResponse<TMenuInfoGetRes[]>) => any} resolve
   * @param {(param: TApiResponse<TMenuInfoGetRes[]>) => any} reject
   * @memberof MenuService
   */
  get = async (id: string | number, signal?: AbortSignal) => {
    try {
      const res: AxiosResponse<TApiResponse<TBusyoInfoGetRes>> =
        await this.getInner(`/master/busyo/${id}`, signal)
      return res.data

      //TODO: api実装必要
    } catch (err) {
      throw err
    }
  }

  /**
   * 単体登録
   *
   * @param {TKyotenPostReq} data
   * @param {(param: TApiResponse<TKyotenRes>) => any} resolve
   * @param {(param: AxiosError<TApiResponse<TKyotenRes>>) => any} reject
   * @memberof KyotenService
   */
  post = async (data: TBusyoRegisterPostReq, signal?: AbortSignal) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.postInner(
        `master/busyo/`,
        data,
        signal
      )
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 単体更新
   *
   * @param {TKyotenPostReq} data
   * @param {(param: TApiResponse<TKyotenRes>) => any} resolve
   * @param {(param: AxiosError<TApiResponse<TKyotenRes>>) => any} reject
   * @memberof KyotenService
   */
  put = async (
    id: number,
    data: TBusyoRegisterPostReq,
    signal?: AbortSignal
  ) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.putInner(
        `master/busyo/${id}`,
        data,
        signal
      )
      return res.data
    } catch (err) {
      throw err
    }
  }
}
